<img [appStoryblok]="_editable" class="img-fluid" [ngClass]="{'clickable withOpacity':url?.url}" [src]="image.filename" [attr.alt]="image.name" [attr.title]="image.name" (click)="gotoUrl()"/>
